import { VbzModal, VbzLoadingLogo } from '@smiles/voebiz-ui-kit';

import React, { FC } from 'react';
import { ModalBody } from 'reactstrap';

interface LoadingModalProps {
  isOpen: boolean;
  onClosed: () => void;
}

const LoadingModal: FC<LoadingModalProps> = ({ isOpen, onClosed }) => {
  return (
    <div>
      <VbzModal desktopSize="small" defaultHeader={false}>
        <ModalBody className="vbz-modal-loading">
          <div className="vbz-modal-loading">
            <div className="LoadingModal_wrapper_loader">
              <VbzLoadingLogo id="loader" />
            </div>
            <div className="LoadingModal_wrapper_text-loading">
              <p>Um momento...</p>
              <p>Estamos enviando seus dados</p>
            </div>
          </div>
        </ModalBody>
      </VbzModal>
    </div>
  );
};

export default LoadingModal;
